import * as Yup from "yup";

import { Alert, Divider, Grid } from "@mui/material";
import { Form, Formik } from "formik";

import PrimaryButton from "../../../components/custom/PrimaryButton";
import TextField from "../../../components/custom/TextField";
import { firstLogin } from "./firstLoginService";
import { styled } from "@mui/system";
import useAuth from "../../../hooks/useAuth";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const StyledDivider = styled(Divider)`
  align-self: center;
  justify-self: center;
  display: flex;

  &.MuiDivider-root {
    border-color: ${(props) => props.theme.palette.background.mouseGrey};

    height: 0.125rem;
  }
`;

const FirstLogin = () => {
  const [error, setError] = useState("");
  const [{ setAuthState }] = useAuth();
  const navigate = useNavigate();

  const { mutate: loginMutate } = useMutation(firstLogin, {
    onSuccess: ({ data: { user, token, isInitialized } }) => {
      setAuthState(user, token, true, isInitialized);
      navigate("/");
    },
    onError: (error) => {
      console.error(error);

      switch (error) {
        default: {
          setError(error.message);
          setTimeout(() => setError(null), 5000);
        }
      }
    },
  });

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Please Enter your password")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .min(8)
      .max(16),
    password2: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Passwords must match"
    ),
  });
  return (
    <Grid container marginTop={20}>
      <Formik
        initialValues={{ password: "newPass", password2: "newPass" }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting, setStatus }) => {
          loginMutate(values);
          setSubmitting(false);
        }}
      >
        {({
          submitForm,
          isSubmitting,
          touched,
          errors,
          setFieldValue,
          values,
          status,
          handleSubmit,
        }) => (
          <Form>
            <Grid container sx={{ width: "100%" }} spacing={5}>
              <Grid item xs={12} sx={{ marginTop: 10 }}>
                {error && (
                  <Alert
                    sx={{ marginTop: 5, marginBottom: 5 }}
                    severity="error"
                  >
                    {error}
                  </Alert>
                )}
                <TextField
                  required
                  label="New password"
                  name="password"
                  placeholder="your email"
                  type="password"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  label="Re enter password"
                  name="password2"
                  placeholder="your password"
                  type="password"
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  width: "100%",
                  justifyContent: "flex-end",
                  display: "flex",
                  marginTop: 10,
                }}
              >
                <PrimaryButton
                  type="submit"
                  onClick={submitForm}
                  sx={{ width: 200 }}
                >
                  Change password
                </PrimaryButton>
              </Grid>
              <Grid item>
                <StyledDivider />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Grid>
  );
};

export default FirstLogin;
